"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Yup = __importStar(require("yup"));
var hljs_1 = require("react-syntax-highlighter/dist/cjs/styles/hljs");
var quiz_machine_1 = __importDefault(require("../machines/quiz-machine"));
var config_1 = __importDefault(require("../config"));
var formik_1 = require("formik");
var react_1 = require("@xstate/react");
var isArray_1 = __importDefault(require("lodash/isArray"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var last_1 = __importDefault(require("lodash/last"));
var first_1 = __importDefault(require("lodash/first"));
var pickBy_1 = __importDefault(require("lodash/pickBy"));
var submit_answer_1 = __importDefault(require("../utils/submit-answer"));
function useQuestion(_a) {
    var _this = this;
    var currentQuestion = _a.currentQuestion, questionSet = _a.questionSet, config = _a.config, currentAnswer = _a.currentAnswer, _b = _a.syntaxHighlighterTheme, syntaxHighlighterTheme = _b === void 0 ? hljs_1.nightOwl : _b, _c = _a.handleSubmitAnswer, handleSubmitAnswer = _c === void 0 ? submit_answer_1.default : _c, currentQuestionKey = _a.currentQuestionKey;
    var _d = (0, react_1.useMachine)(quiz_machine_1.default, {
        context: {
            questionSet: questionSet,
            config: config,
            handleSubmitAnswer: handleSubmitAnswer,
            currentQuestionKey: currentQuestionKey,
        },
    }), state = _d[0], send = _d[1];
    var parsedCurrentAnswer = currentAnswer && currentQuestion && (0, isArray_1.default)(currentQuestion.correct)
        ? (0, isArray_1.default)(currentAnswer)
            ? currentAnswer
            : currentAnswer.split(',')
        : currentAnswer;
    React.useEffect(function () {
        currentQuestion &&
            send('LOAD_QUESTION', { currentQuestion: currentQuestion, currentQuestionKey: currentQuestionKey });
        currentAnswer &&
            currentQuestion &&
            send('ANSWER', {
                answer: parsedCurrentAnswer,
            });
    }, [
        parsedCurrentAnswer,
        currentQuestion,
        currentAnswer,
        send,
        currentQuestionKey,
    ]);
    React.useEffect(function () {
        if (process.env.NODE_ENV === 'development') {
            console.log(state.value, state.context);
        }
    }, [state]);
    var question = state.context.currentQuestion;
    var correct = (question || {}).correct;
    var isAnswered = state.matches('answered');
    var isSubmitting = state.matches('answering');
    var answeredNeutral = state.matches('answered.neutral');
    var answeredCorrectly = state.matches('answered.correct');
    var hasCorrectAnswer = !(0, isEmpty_1.default)(correct);
    var hasMultipleCorrectAnswers = (0, isArray_1.default)(correct);
    var questionsKeys = questionSet && Object.keys(questionSet);
    var lastQuestionKey = (0, last_1.default)(questionsKeys);
    var isLast = questionSet && lastQuestionKey
        ? questionSet[lastQuestionKey] === currentQuestion
        : false;
    var questionId = (0, first_1.default)(Object.keys((0, pickBy_1.default)(questionSet, currentQuestion)));
    function isCorrectChoice(choice) {
        return correct && hasMultipleCorrectAnswers
            ? correct.includes(choice.answer)
            : correct === (choice === null || choice === void 0 ? void 0 : choice.answer);
    }
    var formik = (0, formik_1.useFormik)({
        initialValues: {
            answer: currentAnswer ? currentAnswer : null,
        },
        validationSchema: Yup.object({
            answer: correct
                ? hasMultipleCorrectAnswers
                    ? Yup.array()
                        .required('Pick at least one option.')
                        .label('Options')
                        .nullable()
                    : Yup.string().required('Pick an option.').nullable()
                : Yup.string()
                    .nullable()
                    .required("Can't stay empty. Mind to elaborate? :)"),
        }),
        onSubmit: function (values) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, send('ANSWER', { answer: values.answer })];
            });
        }); },
        validateOnChange: true,
        validateOnBlur: false,
        enableReinitialize: true,
    });
    return {
        currentQuestion: question,
        currentQuestionKey: currentQuestionKey,
        currentQuestionId: questionId,
        isCorrectChoice: function (choice) { return isCorrectChoice(choice); },
        answeredCorrectly: answeredCorrectly,
        answeredNeutral: answeredNeutral,
        onSubmit: formik.handleSubmit,
        hasMultipleCorrectAnswers: hasMultipleCorrectAnswers,
        hasCorrectAnswer: hasCorrectAnswer,
        isSubmitting: isSubmitting,
        isAnswered: isAnswered,
        questionSet: questionSet,
        formik: formik,
        isLast: isLast,
        currentAnswer: currentAnswer,
        answer: state.context.answer,
        config: config || (0, config_1.default)({}),
        syntaxHighlighterTheme: syntaxHighlighterTheme || hljs_1.nightOwl,
    };
}
exports.default = useQuestion;
